import { Flex, Modal } from 'antd';
import React, { useCallback } from 'react'
import { Alert, Button, Table } from 'react-bootstrap';
import AlidaLoader from '../common/AlidaLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useSelector } from 'react-redux';
import { sectionLabelsSelector } from '../../slices/sectionsSlice';
import { RootState } from '../../store';

type Props = {
  show: boolean;
  onClose: VoidFunction;
  error?: boolean;
  title?: string;
  preview: any[] | undefined;
}

export default function DatasetPreviewModal({ title = "Dataset Preview", preview, show, onClose, error }: Props) {

  const datasetLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "datasets"));

  const renderPreview = useCallback(() => {
    if (!preview) return (
      <div className="d-flex justify-content-center py-3">
        <AlidaLoader size={250} />
      </div>
    )

    if (error) return (
      <Alert variant="danger" className="m-2">
        <FontAwesomeIcon icon={solid('exclamation-triangle')} />
        <span className="ms-2">An error occurred. Try again later.</span>
      </Alert>
    )

    return preview.length > 0
      ? (
        <div className="table-wrapper">
          <Table className="mb-0" bordered>
            <thead>
              <tr>
                {Object.keys(preview[0]).map(key => (
                  <th key={key}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {preview.map((row, i) => (
                <tr key={i}>
                  {Object.keys(row).map((col, j) => (
                    <td key={j}>{row[col]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
      : (
        <Alert variant="info" className="py-2 mb-0">
          <FontAwesomeIcon icon={solid("info-circle")} />
          <span className="ms-2">{datasetLabels.singular} is empty.</span>
        </Alert>
      )
  }, [preview, error, datasetLabels]);

  return (
    <Modal
      open={show}
      onClose={onClose}
      onCancel={onClose}
      title={title}
      width={600}
      footer={
        <Flex justify="center">
          <Button onClick={onClose} size="sm" variant="light" className="border">Close</Button>
        </Flex>
      }
    >
      {renderPreview()}
    </Modal>
  )
}